import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function ViewCollectionPointsDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const collectionPointDetails = location.state?.collectionPointDetails || {};

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className='row text-end'>
                <div className='col'>
                  <button type="button" class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)"
                    }}
                    onClick={() => navigate("/collectionpoint-details")}
                  >
                    Back
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Collection Point Details of :  {collectionPointDetails.collection_point_category_name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Collection Points Category Name</label>
                          <input
                            type="text"
                            name="collection_point_category_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.collection_point_category_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Zone Name</label>
                          <input
                            type="text"
                            name="zone_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.zone_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Circle Name</label>
                          <input
                            type="text"
                            name="circle_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.circle_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Ward Name</label>
                          <input
                            type="text"
                            name="ward_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.ward_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Point Name</label>
                          <input
                            type="text"
                            name="point_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.point_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Latitude</label>
                          <input
                            type="text"
                            name="latitude"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.latitude}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Longitude</label>
                          <input
                            type="text"
                            name="longitude"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.longitude}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Shift Name</label>
                          <input
                            type="text"
                            name="shift_name"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.shift_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">PickUp Time</label>
                          <input
                            type="text"
                            name="pickup_times"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.pickup_times}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">LandMark</label>
                          <input
                            type="text"
                            name="pickup_times"
                            className="form-control"
                            readOnly
                            value={collectionPointDetails.pickup_times}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={collectionPointDetails.status === "1" ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewCollectionPointsDetails
